// extracted by mini-css-extract-plugin
export var standaloneTable = "_dr-0";
export var standaloneTableWithBodyFill = "_dr-1";
export var withExtraHeader = "_dr-2";